var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 60 60",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/ ad types / banner ads@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "81.9631198%",
    y1: "5.00173788%",
    x2: "15.8230337%",
    y2: "84.2330549%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#62A8F4",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#336EE0",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/-ad-types-/-banner-ads",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "box",
    x: 0,
    y: 0,
    width: 60,
    height: 60
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9937571,16.0025655 C34.6583973,16.00286 39.3233402,16.0016821 43.9882831,16.0031545 C46.4944943,16.0040379 47.9936808,17.4457814 47.9954969,19.879607 C48.0012479,26.6277676 48.0018532,33.3759282 47.9951942,40.1240888 C47.9927728,42.5378902 46.4730039,43.9970076 43.9743597,43.997891 C34.6444739,44.0008358 25.3145881,44.0008358 15.985005,43.9970076 C13.5468973,43.9958297 12.0092702,42.5152157 12.0062433,40.1473522 C11.9977682,33.3747503 11.9980709,26.6021484 12.0062433,19.829252 C12.0089675,17.4884801 13.5263149,16.0093384 15.9232578,16.0046268 C20.6133233,15.9957926 25.3033889,16.002271 29.9937571,16.0025655 Z M43.5863207,19.383624 C39.071811,19.4146329 34.5569987,19.3993203 30.0421863,19.3993203 L16.5734198,19.3996148 C15.536061,19.3996148 15.4895738,19.400423 15.4874924,20.2986124 L15.4873949,20.4267392 C15.4867896,26.219627 15.4867896,32.0122202 15.4880003,37.8048135 C15.4880003,38.0745514 15.4689313,38.3498844 15.5158471,38.6128495 C15.6502381,39.3608128 16.475048,39.6588202 17.0722406,39.1744109 C17.2816969,39.0039106 17.4511991,38.7824663 17.621004,38.5707397 C19.2630566,36.5262084 20.8930019,34.4728429 22.5441351,32.435379 C23.1988373,31.6270485 23.6113936,31.6305822 24.2942454,32.4023979 C24.9840588,33.1821645 25.6620676,33.9719431 26.3418926,34.7599548 C27.242373,35.8038643 27.7545118,35.8023919 28.59718,34.7384583 C30.073968,32.8732615 31.5477291,31.0060034 33.0202795,29.1378619 C33.8723308,28.0571432 34.2752012,28.0627382 35.1284632,29.1767324 C35.2038312,29.2750867 35.2795018,29.3731464 35.3551725,29.4715007 C37.7454563,32.5675977 40.1296864,35.6681119 42.5357097,38.75243 C42.7487982,39.0254072 43.0747873,39.3069241 43.3995656,39.3867265 C44.0833254,39.554871 44.4998166,39.0380696 44.5001192,38.1113607 C44.5025407,32.1715305 44.489828,26.2314059 44.5171096,20.2915758 C44.520399,19.5833664 44.317299,19.3787071 43.5863207,19.383624 Z M25.4671704,23.049617 C26.8522455,23.0390159 28.1032324,24.2239783 28.1241175,25.5661897 C28.1450026,26.90899 26.9369966,28.1192772 25.542841,28.1525527 C24.1268922,28.1861227 22.8538095,26.9776024 22.8547171,25.6009376 C22.8556256,24.2487141 24.072712,23.060218 25.4671704,23.049617 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner1);
export default __webpack_public_path__ + "static/media/banner1.24e1dc0f73bed5aa3463d6c0f6e0413d.svg";
export { ForwardRef as ReactComponent };